// Written by web/scripts/pack-studio.mjs: the packed studio files' sizes, for the loading progress.
export const MODEL_BYTES = { desktop: 4624224, phone: 3086116 };
